import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, provide, reactive } from "vue";
import userStore from "@/store/modules/user.js";
import { storeToRefs } from "pinia";
export default {
  __name: 'App',
  setup(__props) {
    const user = userStore();
    const {
      userInfo
    } = storeToRefs(user);
    console.log(userInfo, "userInfo");
    const debounce = (fn, delay) => {
      let timer = null;
      return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      };
    };
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
      constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
      }
    };
    const schoolYears = computed(() => {
      const options = [];
      for (const i of [0, 1, 2, 3, 4]) {
        options.push({
          label: `${Number(userInfo.value.schoolYear) - i}-${Number(userInfo.value.schoolYear) - i + 1}`,
          value: `${Number(userInfo.value.schoolYear) - i}`
        });
      }
      return options;
    });
    const schoolTerms = computed(() => {
      const options = [];
      for (let index = 0; index < ["一", "二"].length; index++) {
        options.push({
          label: `第${["一", "二"][index]}学期`,
          value: String(index + 1)
        });
      }
      return options;
    });
    provide("schoolYears", schoolYears);
    provide("schoolTerms", schoolTerms);
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
};